<div class="m-24">
    <div class="flex flex-row justify-between items-center mb-16">      
        <div class="flex flex-col">
            <div class="mat-headline-5 fw-600 fs-20 mb-8">{{'BLUEPRINT_SUMMARY.SERVICE_DEFINITION' | transloco }}:{{'ADD_INSTANCE.VERSION' | transloco}}{{version?.version}}</div>
            <div>
                <span class="environment-color pl-16 pr-16 pt-8 pb-8 ">{{ instance.deploymentClass === 'D' ? 'DEV' : instance.environment }}</span>
                <span class="border-left font-color ml-10 mt-10"></span>
                <span class="config-header pl-16">{{'INSTANCE_SUMMARY.SERVICE_DEFINITION.CREATED_ON' | transloco}}: {{version?.dateCreated | date: 'dd MMM yyyy, HH:mm' + ' UTC'}}</span></div>
        </div>
        <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
    </div>
    <mat-divider class="neutral-2 mb-16"></mat-divider>
    <div *ngIf="version?.capabilities?.length">
        <div class="mat-headline-5 fw-700 fs-16 mb-24">
            {{'INSTANCE_SUMMARY.SERVICE_DEFINITION.SELECTED_CAPABILITIES' | transloco}}
            ({{version?.capabilities?.length}})
        </div>
        <div class="flex flex-wrap card-gap">
            <ng-container *ngFor="let capability of version.capabilities">
                <div class="mb-24 btn-bgcolor">
                    <app-view-capability-card [capability]="capability">
                    </app-view-capability-card>
                </div>
            </ng-container>
        </div>
    </div>
</div>